import React from 'react';
import { Button } from '@mui/material';
import { ClassNameMap } from '@mui/material';

interface ActionButtonsProps {
  classes: ClassNameMap<string>;
  handleNo: () => void;
  handleYes: () => void;
}

const ActionButtons = ({ classes, handleNo, handleYes }: ActionButtonsProps) => (
  <>
    <Button size="large" className={classes.noButton} onClick={handleNo}>
      No
    </Button>
    <Button size="large" variant="contained" className={classes.yesButton} onClick={handleYes}>
      Yes
    </Button>
  </>
);

export default ActionButtons;
